/**
 * Base URL for WMS API (must end with `/wms/`).
 * Set `WMS_API_BASE_URL` when the default dev host is unreachable (e.g. VPN/DNS).
 * Example: WMS_API_BASE_URL=https://businessapi.societynotebook.com/wms/
 */
export function apiURL() {
    const override = process.env.WMS_API_BASE_URL;
    if (override && String(override).trim() !== '') {
        const u = String(override).trim();
        return u.endsWith('/') ? u : `${u}/`;
    }
    let serviceURL = '';
    if (process.env.NODE_ENV === 'production') {
        serviceURL = 'https://businessapi.societynotebook.com/wms/';
    } else if (process.env.NODE_ENV === 'development') {
        serviceURL = 'http://kosn.kifayatonline.in/wms/';
    } else {
        serviceURL = 'http://kosn.kifayatonline.in/wms/';
    }
    return serviceURL;
}